/* eslint sort-keys: "error" */

import { relayStylePagination } from '@apollo/client/utilities';
import * as _ from 'lodash-es';
import moment from 'moment';
import type { TypedTypePolicies } from '../../graphql/generated/apolloTypedTypePolicies';
import baseTypePolicies from '../../graphql/generated/baseTypePolicies';

const typePolicies: TypedTypePolicies = _.merge(baseTypePolicies, {
  Activity: { keyFields: ['actedAt', 'actor'] },
  BillingPricing: { merge: true },
  Contribution: { keyFields: ['user', ['id']] },
  CurrentUser: { keyFields: [] },
  CustomDomain: { keyFields: ['hostname'] },
  Image: { keyFields: false, merge: true },
  IntegrationSettings: { keyFields: false, merge: true },
  MentionPreview: { merge: true },
  Organization: {
    fields: { auditLogs: relayStylePagination(['types', 'user']) },
    merge: true,
  },
  OrganizationSettings: { keyFields: false, merge: true },
  Post: {
    fields: {
      userViewedAt: {
        merge: (existing, incoming) => {
          if (!existing) return incoming;
          return moment(existing).isBefore(moment(incoming))
            ? incoming
            : existing;
        },
      },
    },
  },
  Query: {
    fields: {
      currentSession: { keyFields: false, merge: true },
      insightLeaderboard: relayStylePagination([
        'type',
        'startDate',
        'endDate',
      ]),
      insightTopPosts: relayStylePagination(['startDate', 'endDate']),
      insightTopSearches: relayStylePagination([
        'type',
        'startDate',
        'endDate',
        'orderBy',
        'groupId',
      ]),
      post(_value, { args, toReference }) {
        return toReference({
          __typename: 'Post',
          id: args!.id,
        });
      },
      publicSearch: relayStylePagination(),
      search: relayStylePagination(['filter', 'query']),
      topic(_value, { args, toReference }) {
        return toReference({
          __typename: 'Topic',
          id: args!.id,
        });
      },
      unorganized: relayStylePagination(['filter', 'orderBy']),
    },
  },
  Topic: {
    fields: {
      membership: { merge: true },
      posts: relayStylePagination(['orderBy', 'type']),
    },
  },
  User: { merge: true },
  UserSettings: { merge: true },
  UserSidebarSettings: { merge: true },
} as TypedTypePolicies);

export default typePolicies;
